<template>
    <section class="mission-section">
        <div class="background-word" aria-hidden="true">MMP</div>

        <div class="container mission-content">
            <p class="eyebrow">
                <span></span>
                {{ t.mission.eyebrow }}
            </p>

            <h2>
                {{ t.mission.titleFirst }}
                <em>{{ t.mission.titleSecond }}</em>
            </h2>

            <div class="mission-values">
                <article v-for="(value, index) in t.mission.values"
                         :key="value.title">
                    <span class="value-number">
                        {{ String(index + 1).padStart(2, '0') }}
                    </span>

                    <div class="value-icon" aria-hidden="true">
                        <svg v-if="index === 0"
                             viewBox="0 0 24 24">
                            <path d="M12 3 4 7v5c0 5 3.4 8 8 9 4.6-1 8-4 8-9V7l-8-4Z" />
                            <path d="m8.5 12 2.2 2.2 4.8-5" />
                        </svg>

                        <svg v-else-if="index === 1"
                             viewBox="0 0 24 24">
                            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z" />
                            <path d="M8 9h8M8 13h5" />
                        </svg>

                        <svg v-else
                             viewBox="0 0 24 24">
                            <path d="M4 20V10l8-6 8 6v10" />
                            <path d="M8 20v-6h8v6M3 20h18" />
                        </svg>
                    </div>

                    <h3>{{ value.title }}</h3>
                    <p>{{ value.description }}</p>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'MissionSection',

  props: {
    t: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
    .mission-section {
        position: relative;
        padding-block: var(--section-padding);
        overflow: hidden;
        color: var(--color-white);
        background-color: var(--color-charcoal);
    }

        .mission-section::before {
            position: absolute;
            top: 0;
            right: 11%;
            width: 1px;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.06);
            content: "";
        }

    .background-word {
        position: absolute;
        top: -115px;
        right: -30px;
        color: rgba(255, 255, 255, 0.035);
        font-size: clamp(190px, 25vw, 390px);
        font-weight: 900;
        letter-spacing: -0.08em;
        line-height: 1;
        pointer-events: none;
        user-select: none;
    }

    .mission-content {
        position: relative;
        z-index: 2;
    }

    .eyebrow {
        display: flex;
        align-items: center;
        gap: 13px;
        margin-bottom: 25px;
        color: #efa46d;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.21em;
        text-transform: uppercase;
    }

        .eyebrow span {
            width: 32px;
            height: 2px;
            background-color: currentColor;
        }

    h2 {
        max-width: 950px;
        margin: 0;
        font-family: var(--font-heading);
        font-size: clamp(58px, 7vw, 105px);
        font-weight: 400;
        letter-spacing: -0.045em;
        line-height: 0.92;
    }

        h2 em {
            display: block;
            color: var(--color-orange);
            font-weight: 400;
        }

    .mission-values {
        display: grid;
        margin-top: 90px;
        grid-template-columns: repeat(3, 1fr);
        border-top: 1px solid rgba(255, 255, 255, 0.16);
    }

        .mission-values article {
            position: relative;
            min-height: 290px;
            padding: 38px 45px 10px 0;
            border-right: 1px solid rgba(255, 255, 255, 0.13);
        }

            .mission-values article:not(:first-child) {
                padding-left: 45px;
            }

            .mission-values article:last-child {
                border-right: 0;
            }

    .value-number {
        color: var(--color-orange);
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.1em;
    }

    .value-icon {
        display: grid;
        width: 48px;
        height: 48px;
        margin-top: 28px;
        place-items: center;
        color: #efa46d;
        border: 1px solid rgba(239, 164, 109, 0.45);
    }

        .value-icon svg {
            width: 24px;
            fill: none;
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.5;
        }

    h3 {
        margin: 24px 0 14px;
        font-family: var(--font-heading);
        font-size: 29px;
        font-weight: 400;
    }

    .mission-values p {
        max-width: 330px;
        margin: 0;
        color: #aaa69e;
        font-size: 15px;
        line-height: 1.75;
    }

    @media (max-width: 800px) {
        .mission-values {
            margin-top: 60px;
            grid-template-columns: 1fr;
        }

            .mission-values article {
                min-height: auto;
                padding: 30px 0;
                border-right: 0;
                border-bottom: 1px solid rgba(255, 255, 255, 0.13);
            }

                .mission-values article:not(:first-child) {
                    padding-left: 0;
                }

                .mission-values article:last-child {
                    border-bottom: 0;
                }

        .value-icon {
            margin-top: 20px;
        }
    }
</style>